export default "__VITE_ASSET__4e6bd938__"